'use strict';

angular.module('openDataApp')
  .controller('MainShowcaseCtrl', ['$scope', '$timeout', '$http', 'ApiService', function ($scope, $timeout, $http, ApiService) {
    var lastNr,
        lastPostal;

    $scope.available = true;

    $scope.submitShowcase = function (postal, nr) {
      if (nr === undefined || postal === undefined) {
        $scope.formStatus = 'Vul beide velden in';
      } else if (nr !== lastNr || postal !== lastPostal) {
        lastNr = nr;
        lastPostal = postal;

        var getAddress = function () {
          $timeout(function () {
            ApiService.getAddress(postal, nr)
              .then(
                function success(response) {
                  if (response.status === 200) {
                    if (response.data.status === 0) {
                      $scope.result = {
                        success: true,
                        street: response.data.straat,
                        number: response.data.huisnummer,
                        postal: response.data.postcode,
                        city: response.data.plaats
                      };
                    } else if (response.data.status === 404) {
                      $scope.result = { notFoundError: true };
                    } else if (response.data.status === 90) {
                      $scope.result = { limitExceeded: true };
                    } else {
                      $scope.result = { error: true };
                    }
                  } else {
                    $scope.result = { error: true };
                  }
                },
                function error() {
                  $scope.result = { error: true };
                }
              );
          }, 200);
          return { pending: true };
        };

        $scope.result = getAddress();
      }
    };
  }]);
